// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jiXr","col":"styles_col__2Cfkl","actions":"styles_actions__1B_HR","conflict":"styles_conflict__2Pneq"};